import { render, staticRenderFns } from "./OptionSelect.vue?vue&type=template&id=072c185e&"
import script from "./OptionSelect.vue?vue&type=script&lang=js&"
export * from "./OptionSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports